import { render } from "./CrudUserQuestions.vue?vue&type=template&id=00ea9b02"
import script from "./CrudUserQuestions.vue?vue&type=script&lang=js"
export * from "./CrudUserQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__